import { cn } from "@lib/cn"

type Size = "sm" | "md" | "lg"

const sizes: Record<Size, string> = {
  sm: "h-7 w-7 text-xs",
  md: "h-9 w-9 text-sm",
  lg: "h-14 w-14 text-lg",
}

export function deriveInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length >= 2) return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase()
  return name.trim().slice(0, 2).toUpperCase()
}

/**
 * One tone (PRD-60 chunk 0). The console's people are admins and directors,
 * not a roster the reader has to tell apart at a glance, so the identity
 * rainbow the professor SPA keeps for students has no job here — and in dark
 * mode it left pastel discs glowing on every table. Accent-soft on
 * accent-ink reads in both themes.
 */
export function Avatar({
  name,
  initials,
  size = "md",
  className,
}: {
  name: string
  /** Override the derived initials. */
  initials?: string
  size?: Size
  className?: string
}) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        "bg-accent-soft text-accent-ink inline-flex shrink-0 items-center justify-center rounded-full font-semibold",
        sizes[size],
        className,
      )}
    >
      {initials ?? deriveInitials(name)}
    </span>
  )
}
